import ApolloDataExportItem from "../../../Domain/ApolloDataExportItem";
import SearchParamsBase from "../../../Elements/SearchParamsBase";
import InputTypesEnum from "../../../Enums/InputTypesEnum";

export default class ApolloDataExportSearchParams extends SearchParamsBase
{
	initialize()
	{
		this.ApolloDataExportId="";
		this.ClientName="";
		this.EmailRecipients="";
		this.Frequency="";
		this.IsActive="true";
	}

	//-------------------------------------------
	//-------- Fields for Search Panel ----------
	//-------------------------------------------

	static fieldsInSearchBox=[
		{fieldName:"ApolloDataExportId",label:"Apollo Data Export Id", className:"col-3", type: InputTypesEnum.Text},
		{fieldName:"ClientName",label:"Query Name", className:"col-3", type: InputTypesEnum.Text},
		{fieldName:"EmailRecipients",label:"Email Recipients", className:"col-6", type: InputTypesEnum.Number},
		{fieldName:"Frequency",label:"Frequency", className:"col-6", type: InputTypesEnum.Select, options: ApolloDataExportItem.getFrequencySelectOptions()},
		{fieldName:"IsActive",label:"Is Active", className:"col-6", type: InputTypesEnum.EmptyYesNoSelect},
	];

	static iconName="fa-solid fa-search";
	static saveType="ApolloDataExportSearchParams";

	//---------------------------

}